import React from "react";
import { Snackbar, SnackbarContent } from "@material-ui/core";
export const MaxImageSizeSnackbar = ({ modalState, setModalState }) => {
    return (
        <Snackbar
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "left"
            }}
            autoHideDuration={3000}
            open={modalState}
            onClose={() => {
                setModalState();
            }}
        >
            <SnackbarContent
                style={{
                    backgroundColor: "red",
                    color: "white"
                }}
                message="Image Size Too Large, Please Choose an Image Under 1MB"
            />
        </Snackbar>
    );
};

export const AddUserSnackbar = ({
    newUserFail,
    newUserSuccess,
    setModalState
}) => {
    return (
        <Snackbar
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "left"
            }}
            autoHideDuration={3000}
            open={newUserFail || newUserSuccess}
            onClose={() => {
                setModalState();
            }}
        >
            <SnackbarContent
                style={{
                    backgroundColor: newUserSuccess
                        ? "green"
                        : newUserFail
                        ? "red"
                        : "white",
                    color: "white"
                }}
                message={
                    newUserSuccess
                        ? "New User Successfully Added !"
                        : newUserFail
                        ? "Unable Add User, Please Contact Admin"
                        : ""
                }
            />
        </Snackbar>
    );
};
